import './agent-filter.component.ajscss';

import { ng1Destroy } from '@commons/util/utilities/rx';
import { UserTrackingFunction } from '@tracking/models/tracking-function';
import { RESET_TRACKING_FILTER } from '@tracking/table/tracking-table.component.ajs';
import { IUserTrackingService } from '@tracking/tracking.service';
import { IComponentController, IComponentOptions } from 'angular';

import { MessagingService } from '@contact/upgrade';

import templateUrl from './agent-filter.component.ajs.html';

const MODULE_NAME = 'contactAgentFilter';

class AgentFilterControler implements IComponentController {
  public name = MODULE_NAME;

  private agentList: Array<any> = [];
  private selectedAgent: any = null;
  private activityList: any[] = [];
  private selectedActivity: any = null;

  constructor(private readonly tracking: IUserTrackingService, private readonly messaging: MessagingService) {}

  $onInit() {
    this.tracking.setFunction(UserTrackingFunction.AGENT);

    this.tracking.getAgentList().then(agents => {
      this.agentList = agents.map(agent => {
        agent.name = `${agent.firstName} ${agent.lastName}`;
        return agent;
      });
    });
    this.activityList = this.tracking.getCsrActivities('viewAgents').map((csrActivity: any) => {
      csrActivity.name = csrActivity.label;
      return csrActivity;
    });

    // RESET_TRACKING_FILTER
    this.messaging
      .forLocal()
      .listen$(RESET_TRACKING_FILTER)
      .pipe(ng1Destroy(this))
      .subscribe(() => this.resetFilters());
  }

  public activityChanged() {
    if (this.selectedActivity?.action) {
      this.tracking.updateFilters('action', this.selectedActivity.action);
      if (this.selectedActivity.hasOwnProperty('target')) {
        this.tracking.updateFilters('targetType', this.selectedActivity.target);
      } else {
        this.tracking.updateFiltersString('targetType', 'NOT_EXISTS');
      }
    } else {
      this.tracking.updateFilters('action', null);
      this.tracking.updateFiltersString('targetType', null);
    }
  }

  private resetFilters(): void {
    this.selectedAgent = undefined;
    this.selectedActivity = undefined;
  }

  public resetActivity() {
    this.selectedActivity = null;
    this.tracking.updateFilters('action', null);
    this.tracking.updateFilters('targetType', null);
  }

  public agentChanged() {
    if (this.selectedAgent?.uuid) {
      this.tracking.updateFilters('userId', this.selectedAgent.uuid);
    } else {
      this.tracking.updateFilters('userId', null);
    }
  }

  get agents(): Array<any> {
    return this.agentList;
  }

  get activities(): Array<any> {
    return this.activityList;
  }
}

export class AgentFilter implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = ['tracking', 'messaging', AgentFilterControler];
}

export default MODULE_NAME;
